import React from 'react';
import './services.css';
import dantelv3 from '../../assets/certification/dantelv3.webp';
import LazyImage from '../../LazyImage';
import { useTranslation } from '../../contexts/TranslationContext';

const Services = () => {
  const { t } = useTranslation();

  return (
    <section id='services'>
      <div className="titreservices">
        <h4 className="h4services">{t('services.title')}</h4>
      </div>

      <div className="container services__container">
        <article className="service3">
          <div className="service__content">

          <div className="service__titre">
            <h3>{t('services.games.title')}</h3>
            <h2 dangerouslySetInnerHTML={{ __html: t('services.games.skills') }}></h2>
          </div>
          <div className="conteneurbandeau">
            <p>{t('services.games.description')}</p>
            {/* <div className="bandeau"><LazyImage className="marquee-imagecertif1" src={wwise101} alt=''/>
              </div> */}
              </div>
          </div>
          
        </article>
        
        <article className="service2">
          <div className="service__content">
            <div className="service__titre">
            <h3>{t('services.cinema.title')}</h3>
            <h2 dangerouslySetInnerHTML={{ __html: t('services.cinema.skills') }}></h2>
           </div>
              <p>{t('services.cinema.description')}</p>
          </div>
        </article>

        <article className="service4">
          <div className="service__content">
          <div className="service__titre">
            <h3>{t('services.music.title')}</h3>
            <h2 dangerouslySetInnerHTML={{ __html: t('services.music.skills') }}></h2>
          </div>
              <p>{t('services.music.description')}</p>
              
          </div>
        
        </article>

                <article className="service1">
          <div className="service__content">

          <div className="service__titre">
            <h3>{t('services.tv.title')}</h3>
            <h2 dangerouslySetInnerHTML={{ __html: t('services.tv.skills') }}></h2>
          </div>
          <div className="conteneurbandeau">
            <p>{t('services.tv.description')}</p>
            <div className="bandeautv"><LazyImage className="marquee-imagecertif" src={dantelv3} alt=''/>
              </div>
              </div>
          </div>
          
        </article>
      </div>
    </section>
  )
}

export default Services